import React from 'react'

export function searchUnified() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 19.2 19.2" fill="none">
      <path
        className="fill"
        d="M15.6 7.8C15.6 9.52125 15.0412 11.1113 14.1 12.4013L18.8475 17.1525C19.3162 17.6213 19.3162 18.3825 18.8475 18.8513C18.3787 19.32 17.6175 19.32 17.1487 18.8513L12.4012 14.1C11.1112 15.0413 9.52125 15.6 7.8 15.6C3.49125 15.6 0 12.1088 0 7.8C0 3.49125 3.49125 0 7.8 0C12.1087 0 15.6 3.49125 15.6 7.8ZM7.8 13.2C10.7812 13.2 13.2 10.7813 13.2 7.8C13.2 4.81875 10.7812 2.4 7.8 2.4C4.81875 2.4 2.4 4.81875 2.4 7.8C2.4 10.7813 4.81875 13.2 7.8 13.2Z"
        fill="#104573"
      />
    </svg>
  )
}
